import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'

// Build marker para identificar claramente a versão do frontend em prod/homolog
// Procure por esta mensagem no console do navegador após o deploy.
console.log('🧱 Site Editor Wicomm:', {
  versionTag: 'frontend-main-v1.01',
  env: import.meta.env.MODE,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster 
          position="top-right"
          containerClassName="!z-[10000]"
          toastOptions={{
            duration: 4000,
            className: 'toast-enter Toaster__toast',
            success: {
              className: 'toast-enter Toaster__toast Toaster__toast--success',
              iconTheme: {
                primary: '#10B981',
                secondary: '#FFFFFF',
              },
            },
            error: {
              className: 'toast-enter Toaster__toast Toaster__toast--error',
              iconTheme: {
                primary: '#EF4444',
                secondary: '#FFFFFF',
              },
            },
            loading: {
              className: 'toast-enter Toaster__toast Toaster__toast--loading',
              iconTheme: {
                primary: '#3B82F6',
                secondary: '#FFFFFF',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
